module.exports = __webpack_public_path__ + "img/vadzim.p__600x600.fd4ec82c.jpg";